module.exports = __webpack_public_path__ + "img/journal.c616368a.svg";